import axios from "axios";
import { SIWSessionDTO } from "./types";
const token = window.localStorage.getItem('requestVerificationToken');
const serviceURL = "/api/ingrid";

// checkout-demo-backend-stage service simulates the shops backend
// It holds a mocked cart and passes requests to SIW service.
// Your actual setup should look similar - You shouldn't call SIW directly from FE in order not to expose the private keys.

// Creates a session with a basic cart, calls siw/session.create under the hood
export const createSession = () => {
  return (
    axios.post<{ session: SIWSessionDTO; html_snippet: string }>(
      `${serviceURL}/session.create`, null, {
      headers: {
        'litium-request-context': window.localStorage.getItem('requestContext'),
        'RequestVerificationToken': token
      },
    },
    ).catch(error => {
      console.warn(error);
    }))
}
//Returns an existing session, calls siw/session.get under the hood

export const getSession = (sessionID: string) => {
    return (
        axios.get<{ session: SIWSessionDTO; html_snippet: string }>(`${serviceURL}/session.get?sessionId=` + sessionID, {
            headers: {
                'litium-request-context': window.localStorage.getItem('requestContext'),
                'RequestVerificationToken': token
            }
    }).catch(error => {
      console.warn(error);
    }))
   
}
//Adds a new product the the cart and bumps the price, calls siw/session.update under the hood
export const updateSession = (sessionID: string) => {
  return (
    axios.post<{ session: SIWSessionDTO; html_snippet: string }>(`${serviceURL}/session.update?sessionId=` + sessionID,
      null,
      {
        headers: {
          'litium-request-context': window.localStorage.getItem('requestContext'),
          'RequestVerificationToken': token
        }
      }
  )
  .catch(error => {
    console.warn(error);
  }))
  
}
